import React from 'react';
import PropTypes from 'prop-types';

import VpButton from '../VpButton';
import { VpIcon } from '../VpIcon';
import { StyledVpButton, StyledButtonGroup } from './styles';

export const VpButtonGroup = ({ labelIcon, label, icon = 'ChevronDown', disabled, ...rest }) => {
  return (
    <StyledButtonGroup variant="outlined" disabled={disabled} {...rest}>
      <StyledVpButton variant="outlined" color="neutral">
        {labelIcon && <VpIcon icon={labelIcon} />}
        {label}
      </StyledVpButton>
      <VpButton size="small" variant="outlined" color="neutral">
        <VpIcon icon={icon} />
      </VpButton>
    </StyledButtonGroup>
  );
};

VpButtonGroup.propTypes = {
  labelIcon: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.string,
  disabled: PropTypes.bool
};

export default VpButtonGroup;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpButtonGroup/VpButtonGroup.jsx